import { Spinner } from '@shared/components/spinner';

/**
 * Sending screen (spec §10 — sending_to_lpos).
 *
 * Shown immediately after Confirm while the write is in flight.
 * No action is offered — the file is on its way and can't be cancelled
 * (the point of no clean return). Auto-advances when the backend transitions
 * to waiting_for_lpos, paused_lpos_busy, or failed.
 */
export function SendingScreen() {
  return (
    <div
      role="status"
      className="flex flex-col items-center justify-center gap-3 py-12 text-gray-600"
      data-testid="sending-screen"
    >
      <Spinner sizeClass="w-8 h-8" />
      <p className="text-sm">Sending your receiving to LiquorPOS…</p>
    </div>
  );
}
